<style lang="scss">
.m2_exam-reg-menu {
  line-height: 0;
  text-align: center;
  ul {
    margin-bottom: 20px;
    display: inline-block;
    li {
      float: left;
      margin-left: 20px;
      color: #666666;
      cursor: default;
      height: 28px;
      line-height: 28px;
      padding: 0 10px;
      vertical-align: middle;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .active {
    background-color: #009cfe;
    color: white;
    border-radius: 20px;
    .arrow-up {
      width: 0;
      height: 0;
      margin: 0 auto;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
    }
  }
}
</style>
<template>
  <div class="m2_exam-reg-menu">
    <ul>
      <li :class="{active:menuIndex==6}" v-if="batchNum>1">选择批次</li>
      <li :class="{active:menuIndex==1}" v-if="promiseState">考生承诺书</li>
      <li :class="{active:menuIndex==2}">考生信息采集</li>
      <li :class="{active:menuIndex==4}">确认提交信息</li>
      <li :class="{active:menuIndex==5}" v-if="paySwitchStatus">报名完成</li>
      <div class="clear"></div>
    </ul>
  </div>
</template>

 <script >
export default {
  props: {
    menuIndex: {
      default: "0"
    }
  },
  data: function() {
    return {
      batchNum: "",
      promiseState: "",
      paySwitchStatus: ""
    };
  },
  created: function() {
    if (this.$store.state.examRegInfo.examRegInfo) {
      this.examRegInfo = this.$store.state.examRegInfo.examRegInfo.pay_switch_status;
    } else {
      this.examRegInfo = false;
    }
    if (this.$store.state.examRegInfo.promiseState) {
      this.promiseState = this.$store.state.examRegInfo.promiseState;
    } else {
      this.promiseState = false;
    }
    if (this.$store.state.examInfo.batch) {
      this.batchNum = this.$store.state.examInfo.batch;
    } else {
      this.batchNum = false;
    }
  }
};
</script>